export default __webpack_public_path__ + "static/Scroll-Image---Brick-Removal-9b336e759791b4485b2da800bcaa0833.jpg";